import { FC, useState } from 'react';
import WhatsappDocuments from './WhatsappDocuments';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../../../../auth';
import { useLocation } from 'react-router-dom';
import { generateAddress } from '../../../../../../../_metronic/helpers';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

export const TextileSaleOrderPopUp: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { currentUser } = useAuth()
    const userType = (currentUser as any).userType;

    const [selectedDocs, setSelectedDocs] = useState<any[]>([]);

    const handleDocToggle = (doc: any) => {
        const isSelected = selectedDocs.some(d => d.docUrl === doc.docUrl);
        if (isSelected) {
            setSelectedDocs(selectedDocs.filter(d => d.docUrl !== doc.docUrl));
        } else {
            setSelectedDocs([...selectedDocs, doc]);
        }
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
            contentClassName="shadow-lg rounded-3"
        >
            <div className="modal-header border-0 pb-0 justify-content-end">
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2" onClick={onClose}>
                    <i className="bi bi-x fs-1"></i>
                </div>
            </div>

            <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                <div className="text-center mb-13">
                    <h1 className="mb-3">View Order Details</h1>
                    <div className="text-muted fw-semibold fs-5">Order ID: <span className="text-primary">{user?.saleOrderId || 'N/A'}</span></div>
                </div>

                <div className="row g-5 mb-8">
                    <div className="col-md-6">
                        <div className="bg-light-primary rounded p-5 h-100">
                            <h4 className="text-primary fw-bold mb-3">Buyer Information</h4>
                            <div className="fs-6 fw-semibold text-gray-700">
                                <div><span className="text-gray-500 me-2">Name:</span> {user?.sellerName || 'N/A'}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="bg-light-success rounded p-5 h-100">
                            <h4 className="text-success fw-bold mb-3">Supply Address</h4>
                            <div className="fs-6 fw-semibold text-gray-700">
                                {generateAddress(user?.sellerAddress?.[0]) || 'N/A'}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card shadow-sm border border-gray-200 mb-8">
                    <div className="card-header border-0 bg-light-dark py-2 min-h-40px">
                        <h3 className="card-title fs-5 fw-bold text-gray-800 m-0">Order Specifications</h3>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4 m-0">
                                <tbody>
                                    <tr>
                                        <td className="ps-6 fw-bold text-gray-600 w-50">Category</td>
                                        <td className="text-dark fw-semibold">{user?.orderDetail?.[0]?.categoryName || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-6 fw-bold text-gray-600">Item</td>
                                        <td className="text-dark fw-semibold">{user?.orderDetail?.[0]?.items?.[0]?.itemName || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-6 fw-bold text-gray-600">Grade</td>
                                        <td className="text-dark fw-semibold">{user?.orderDetail?.[0]?.items?.[0]?.gradeName || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-6 fw-bold text-gray-600">Quantity (Kgs)</td>
                                        <td className="text-dark fw-semibold">{user?.orderDetail?.[0]?.items?.[0]?.quantity || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-6 fw-bold text-gray-600">Approved Quantity (Kgs)</td>
                                        <td className="text-dark fw-semibold">{user?.confirmOrderQuantity || 'N/A'}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-6 fw-bold text-gray-600 pb-4 border-bottom-0">Price (INR/Kgs)</td>
                                        <td className="text-dark fw-semibold pb-4 border-bottom-0">{user?.orderDetail?.[0]?.items?.[0]?.price || 'N/A'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="row g-5 mb-8">
                    <div className="col-lg-12">
                        <div className="table-responsive border border-gray-200 rounded">
                            <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4 m-0">
                                <thead className="bg-light">
                                    <tr className="fw-bold text-muted">
                                        <th className="ps-4 min-w-150px">Payment Terms</th>
                                        <th className="min-w-150px">Supplied Quantity (Kgs)</th>
                                        <th className="min-w-150px rounded-end">Balance Quantity (Kgs)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="ps-4 text-dark fw-semibold border-bottom-0 pb-4">{user?.paymentTerms?.[0] || 'N/A'}</td>
                                        <td className="text-dark fw-semibold border-bottom-0 pb-4">{user?.consumedQuantity || 'N/A'}</td>
                                        <td className="text-dark fw-semibold border-bottom-0 pb-4">{user?.confirmOrderQuantity - user?.consumedQuantity || '0'}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="row g-5 mb-8">
                    <div className="col-lg-6">
                        <div className="card shadow-sm border border-gray-200 h-100">
                            <div className="card-header border-0 bg-light-dark py-2 min-h-40px">
                                <h3 className="card-title fs-5 fw-bold text-gray-800 m-0">Purchase Order Document</h3>
                            </div>
                            <div className="card-body d-flex flex-column align-items-center justify-content-center p-5">
                                {user?.images?.[0]?.docUrl ? (
                                    <div className="position-relative">
                                        <div className="position-absolute top-0 start-0 translate-middle mt-2 ms-2 z-index-2">
                                            <div className="form-check form-check-custom form-check-solid form-check-sm">
                                                <input
                                                    className="form-check-input border border-gray-400"
                                                    type="checkbox"
                                                    checked={selectedDocs.some(d => d.docUrl === user.images[0].docUrl)}
                                                    onChange={() => handleDocToggle(user.images[0])}
                                                />
                                            </div>
                                        </div>
                                        <div className="border border-dashed border-gray-300 rounded p-2 mb-3">
                                            <img
                                                src={user.images[0].docUrl}
                                                alt="Document"
                                                className="rounded"
                                                style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }}
                                                onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                            />
                                        </div>
                                        <span className="badge badge-light-primary fw-bold fs-7">{user?.images?.[0]?.docNumber || 'Doc Number'}</span>
                                    </div>
                                ) : (
                                    <div className="text-muted fw-semibold py-10">No Document Available</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="card shadow-sm border border-gray-200 h-100">
                            <div className="card-header border-0 bg-light-dark py-2 min-h-40px">
                                <h3 className="card-title fs-5 fw-bold text-gray-800 m-0">Approval Log</h3>
                            </div>
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4 m-0">
                                        <thead className="bg-light">
                                            <tr className="fw-bold text-muted">
                                                <th className="ps-4">Approved By</th>
                                                <th>Date</th>
                                                <th className="pe-4">Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="ps-4 text-dark fw-semibold border-bottom-0 pb-4">{user?.workflowLogs?.[0]?.role || 'N/A'}</td>
                                                <td className="text-gray-700 fw-semibold border-bottom-0 pb-4">
                                                    {user?.workflowLogs?.[0]?.time
                                                        ? new Date(user.workflowLogs[0].time).toLocaleString('en-GB', {
                                                            day: '2-digit', month: '2-digit', year: 'numeric',
                                                            hour: '2-digit', minute: '2-digit', hour12: true
                                                        })
                                                        : 'N/A'}
                                                </td>
                                                <td className="pe-4 text-gray-700 fw-semibold border-bottom-0 pb-4">{user?.workflowLogs?.[0]?.action || 'N/A'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mb-5">
                    <WhatsappDocuments
                        selectedDocs={selectedDocs}
                        setSelectedDocs={setSelectedDocs}
                        orderId={user?.saleOrderId}
                    />
                </div>

                <div className="d-flex justify-content-center mt-10">
                    <button type="button" className="btn btn-light btn-active-light-primary me-3 px-8" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};